import React from "react";

const PageHeading = ({ title, subTitle }) => {
  return (
    <div className="my-2">
      <h4 className="fw-bold mb-1">{title}</h4>
      <p className="text-muted">{subTitle}</p>
    </div>
  );
};

export default PageHeading;
